import Vue from 'vue'
import { POSITION_VALUE_LIST } from '@/constant/css'
import {
  create,
  getStyle,
} from '@/utils/dom'
import CEmptyOption from '../components/CEmpty'
import noData from '../assets/img/no_data.png'

const CEmpty = Vue.extend(CEmptyOption)

const setStyle = (dom, value) => {
  dom.style.position = 'absolute'
  dom.style.top = 0
  dom.style.left = 0
  dom.style.zIndex = value ? 1 : -2 // loading和empty同时存在时loading比empty优先显示
  dom.style.opacity = value ? 1 : 0
  dom.style.transition = 'opacity .3s ease'
  dom.style.overflowY = 'auto'
  dom.style.height = '100%'
  dom.style.width = '100%'
}

export default {
  inserted (el, { value }) {
    if (!POSITION_VALUE_LIST.includes(getStyle(el, 'position'))) {
      el.style.position = 'relative'
    }

    const $empty = create('div')

    el.appendChild($empty)
    let options = {
      imgUrl: noData,
      msg: '暂无数据',
    }

    switch (true) {
      case typeof value === 'boolean': {
        if (value) {
          options = {
            imgUrl: noData,
            msg: '暂无数据',
          }
        }

        break
      }

      case typeof value === 'string': {
        if (value) {
          options = {
            imgUrl: noData,
            msg: value,
          }
        }

        break
      }

      default: {
        options = value

        break
      }
    }
    const c = new CEmpty({
      el: $empty,

      propsData: options,
    })
    el.$empty = c.$el

    setStyle(el.$empty, value)
  },

  update (el, { value }) {
    if (value) {
      if (el.$empty) {
        el.$empty.style.opacity = 1
        el.$empty.style.zIndex = 1
      }
    } else {
      if (el.$empty) {
        el.$empty.style.opacity = 0
        el.$empty.style.zIndex = -1
      }
    }
  },

  unbind (el, { value }) {
    if (el.$empty) {
      // eslint-disable-next-line no-unused-expressions
      el.$empty.__vue__?.$destroy()
      if (el.contains(el.$empty)) {
        el.removeChild(el.$empty)
      }

      delete el.$empty
    }
  },
}
